export default {
    data: () => ({
        translations: {
            title: {
                el: "Ρυθμίσεις",
                en: "Settings Panel",
                it: "Pannello Impostazioni"
            },
            mobilePayments: {
                el: "Εκκαθάριση online πληρωμών",
                en: "Online Payment Processing",
                it: "Elaborazione dei pagamenti online"
            },
            mobilePaymentsInfo: {
                el: "Εντυπωσιάστε τους πελάτες σας με",
                en: `
                    Impress your clients with online payment processing that are made 
                    through the mobile application directly to your store.
                `,
                it: "Stupisci i tuoi clienti con l' elaborazione dei pagamenti online che vengono effetuati tramite l applicazione mobile direttamente nel tuo negozio."
            },
            on: {
                el: "Ενεργό",
                en: "On",
                it: "Sopra"
            },
            off: {
                el: "Ανενεργό",
                en: "Off",
                it: "Off"
            },
            allTransactions: {
                el: "Εξαγωγή όλων των συναλλαγών",
                en: "Export All Transactions",
                it: "Esporta tutte le transazioni"
            },
            latestTransactions: {
                el: "Εξαγωγή τελευταίων συναλλαγών",
                en: "Export Latest Transactions",
                it: "Esporta ultime  transazioni"
            }
        }
    })
};
